module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation3.c40270cd.png";